import React from "react";
import { Helmet } from "react-helmet-async";

const AboutPage = () => {
  return (
    <>
      {/*SEO Meta Tags */}
      <Helmet>
        <title>About Us, SPK Academy & Publishing</title>
        <meta
          name="description"
          content="SPK Academy & Publishing empowers students, authors, and creatives through quality education, publishing, printing, and graphic design services."
        />
        <meta property="og:title" content="About Us, SPK Academy & Publishing" />
        <meta
          property="og:description"
          content="Learn about SPK Academy's vision, mission, and values. We are dedicated to educational and creative solutions that transform lives."
        />
        <meta property="og:url" content="https://spkrobertacademy.com/about" />
        <meta name="robots" content="index, follow" />
      </Helmet>

    <section id="about-us" className="py-12">
      <div className="container mx-auto px-2">
        {/* Header */}
        <div className="bg-gray-300 py-4 rounded-xl mb-3 sm:mb-3">
          <h2 className="text-4xl font-bold text-gray-800 mb-4 text-center">About Us</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto text-left px-3 sm:text-center">
            Welcome to <span className="font-semibold text-blue-600">SPK Academy & Publishing</span>, 
            where we empower students, authors, and creatives to unlock their full potential. 
            Through quality education, innovative publishing, and creative design services, 
            we are dedicated to helping you succeed.
          </p>
        </div>

        {/* Vision, Mission, Values Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-3 sm:mb-3">
          {/* Vision */}
          <div className="bg-white rounded-xl shadow-md p-4 hover:shadow-lg transition-shadow">
            <h3 className="text-2xl font-semibold text-blue-600 mb-4">Our Vision</h3>
            <p className="text-gray-700 leading-relaxed">
              To be a leading provider of educational and creative solutions that inspire 
              success and transform lives.
            </p>
          </div>

          {/* Mission */}
          <div className="bg-white rounded-xl shadow-md p-4 hover:shadow-lg transition-shadow">
            <h3 className="text-2xl font-semibold text-blue-600 mb-4">Our Mission</h3>
            <p className="text-gray-700 leading-relaxed">
              To deliver exceptional services in education, publishing, printing, and 
              graphic design, equipping individuals with the tools and opportunities they 
              need to thrive in their academic, professional, and creative journeys.
            </p>
          </div>

          {/* Values */}
          <div className="bg-white rounded-xl shadow-md p-4 hover:shadow-lg transition-shadow">
            <h3 className="text-2xl font-semibold text-blue-600 mb-4">Our Values</h3>
            <ul className="space-y-3 text-gray-700">
              <li>
                <span className="font-semibold">Excellence:</span> Striving for the highest 
                standards.
              </li>
              <li>
                <span className="font-semibold">Innovation:</span> Embracing creativity and 
                impactful solutions.
              </li>
              <li>
                <span className="font-semibold">Empowerment:</span> Enabling success through 
                learning and creativity.
              </li>
              <li>
                <span className="font-semibold">Integrity:</span> Operating with honesty and 
                transparency.
              </li>
            </ul>
          </div>
        </div>

        {/* Why Choose Us */}
        <div className="bg-blue-50 rounded-xl px-2 py-4 sm:p-6 text-left md:text-left">
          <h3 className="text-3xl font-semibold text-gray-800 mb-4">Why Choose Us?</h3>
          <p className="text-lg text-gray-600 mb-6">
            At SPK Academy & Publishing, we understand the power of education and creativity 
            in shaping lives. We are proud to offer:
          </p>
          <ul className="space-y-3 text-gray-700 max-w-2xl mx-auto md:mx-0">
            <li className="flex items-start">
              <span className="text-blue-500 mr-3">✓</span>
              Personalized and innovative solutions tailored to your unique needs.
            </li>
            <li className="flex items-start">
              <span className="text-blue-500 mr-3">✓</span>
              A team committed to delivering quality and consistent results.
            </li>
            <li className="flex items-start">
              <span className="text-blue-500 mr-3">✓</span>
              Flexible and accessible services designed to fit your schedule and goals.
            </li>
          </ul>
        </div>
      </div>
    </section>
    </>
  );
};

export default AboutPage;